import React from "react";
import Button from "../CommonComponents/Button";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import { isMobile } from "../helperFunc";
import style from "./style.module.css";

const NeedHelpRight = (props) => {
  const { className } = props;
  return (
    <>
      <Card
        className={` boxRadius8 ${style["backgroundImageDesktop"]} ${style["paddingRightCSS"]} margin-top24 margin-bottom24 ${className}`}
      >
        <div>
          <HeadLines
            className=" textColorWhite font-weight600  padding-bottom16 font-size24 line-height28"
            text="Need help?"
          />
        </div>
        <div className="d-flex ">
          <HeadLines
            className=" colorLightGrey font-size20 line-height23 letterSpacing001 font-weight400   "
            text="Toll-free Number"
          />
          <HeadLines
            className=" textColorWhite font-weight500  padding-left16 font-size20 line-height23 "
            text="+91-9015260260"
          />
        </div>
        {/* <Button
          className="boxRadius8 width-100 colorDark5  margin-top16 padding-top8 padding-bottom8 backgroundWhite line-height16 font-size14 font-weight500 letterSpacing0125"
          title="Call Service Desk"
          onClick={() => {
            window.location.href = "tel:+91-9015260260";
          }}
        /> */}
      </Card>
    </>
  );
};
export default NeedHelpRight;
